import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { DatePicker, Inn } from "antd";
import { TimePicker } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import {
  Button,
  Checkbox,
  Select,
  Switch,
  Input,
  Form,
  Tabs,
  Radio,
  Space,
  Tag,
  Col,
  Row,
  Table,
} from "antd";
import {
  HomeOutlined,
  InfoCircleOutlined,
  PayCircleOutlined,
  CameraOutlined,
  SearchOutlined,
  CheckCircleOutlined,
  PlusOutlined,
  MinusOutlined,
  ArrowRightOutlined,
  RightOutlined,
  LeftOutlined,
} from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import PageHeader from "../../Components/PageHeader";
import ImageUploader from "../../Components/ImageUploader/ImageUploader";
import CurriculumCard from "../../Components/curriculum_card/CurriculumCard";
// import Quiz_Result_popup from "../../Components/addQuiz/AddQuiz";
// import AddQuiz from "../../Components/addQuiz/AddQuiz";
// import SortSection from "../CurriculumTab/SortSection";
// import AddSection from "../CurriculumTab/AddSection";
// import AddLesson from "../CurriculumTab/AddLesson";
import useFormDataPost from "../../services/useFormDataPost";
// import SelectInput from "../../Components/SelectInput";
import useGetApi from "../../services/useGetApi";
import SearchSelect from "../../Components/SearchSelect";

// import AddSection from "../../Components/addSection/AddSection";
// import AddLesson from "../../Components/addLesson/AddLesson";
// import SortSection from "../../Components/sortSection/SortSection";
import usePost from "../../services/usePost";
import ZoomSetting from "../zoomSetting/ZoomSetting";
import BbbClasses from '../bBbClass/BbbClasses'
import AcademicProgres from '../academicProgress/AcademicProgres';

const { TabPane } = Tabs;
const { Option } = Select;
const { TextArea } = Input;
dayjs.extend(customParseFormat);

const columns = [
  {
    title: "Student",
    dataIndex: "student",
    key: "student",
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
  },
  {
    title: "Progress",
    dataIndex: "progress",
    key: "progress",
  },
  {
    title: "Actions",
    dataIndex: "actions",
    key: "actions",
    // render: (_, record) => <Quiz_Result_popup />,
    render: (_, record) => <></>,
  },
];

const data = [
  {
    key: "1",
    student: "John Brown",
    date: "2025-02-07",
    progress: "In Progress",
    actions: "",
  },
];

const EditCourse = () => {
  const { TabPane } = Tabs;
  const { Option } = Select;
  const { TextArea } = Input;

  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [value, setValue] = useState(null);
  const [valueForExpiry, setValueForExpiry] = useState(1);
  const [checked, setChecked] = useState(false);
  const [isCheckedForFreeCourse, setIsCheckedForFreeCourse] = useState(false);
  const [isCheckedForDiscountedPrice, setIsCheckedForDiscountedPrice] =
    useState(false);
  const [tags, setTags] = useState([]);
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [faqList, setFaqList] = useState([{ question: "", answer: "" }]);
  const [requirementList, setRequirementList] = useState([{ requirement: "" }]);
  const [outcomesList, setOutcomesList] = useState([{ outcome: "" }]);
  const [loading, setLoading] = useState(false);
  const [thumbnailURL, setThumbnailURL] = useState(null);

  const [categoryOptions, setCategoryOptions] = useState([]);

  const [addSectionBtn,setAddSectionBtn] = useState(false)
  const [addLessonBtn,setAddLessonBtn] = useState(false)
  const [addquizbtn,setAddQuizBtn] = useState(false)
  const [sortSectionBtn,setSortSectionBtn] = useState(false)
  const [editCourse,setEditCourse] = useState()


  useEffect(() => {
    console.log(outcomesList,'././')
  },[outcomesList])

  const [
    isCategoriesDataLoading,
    categoriesDataError,
    categoriesData,
    getCategoriesData,
  ] = useGetApi(`category/getAll?page=0&size=99999&sort=id&sort=asc`, [], true);

  const [
    editCourseDataIsLoading,
    editCourseDataError,
    editCourseData,
    getEditCourseData,
  ] = useGetApi(`course/get?id=${id}`, [], true);

  const { postFormData, formDataPostResult, formDataPostError } =
    useFormDataPost();

  useEffect(() => {
    getCategoriesData(`category/getAll?page=0&size=99999&sort=id&sort=asc`);
  }, []);

    const [isLoading, error, userData, getData] = useGetApi(
      `users/get`,
      [],
      true
    );
  
    useEffect(() => {
      getData(`users/get`);
    }, []);

  useEffect(() => {
    if (categoriesData && categoriesData.content) {
      const options = categoriesData.content.map((category) => ({
        value: category.id,
        label: `#${category.id} ${category.name}`,
      }));
      setCategoryOptions(options);
    }
  }, [categoriesData]);

  useEffect(() => {
    if (id && id != null && id != undefined) {
      getEditCourseData(`course/get?id=${id}`);
    }
  }, [id]);

  useEffect(() => {
    if (editCourseData) {
      console.log("Updated State:", editCourseData);
      setEditCourse(editCourseData) 

      if (editCourseData.faqs) {
        try {
          setFaqList(JSON.parse(editCourseData.faqs));
        } catch (error) {
          setFaqList([{ question: "", answer: "" }]);
        }
      }
      if (editCourseData.isFreeCourse) {
        setIsCheckedForFreeCourse(editCourseData.isFreeCourse);
        form.setFieldValue("isFreeCourse", editCourseData.isFreeCourse);
      }

      if (editCourseData.outcomes) {
        try {
          setOutcomesList(JSON.parse(editCourseData.outcomes));
        } catch (error) {
          setOutcomesList([{ outcome: "" }]);
        }
      }
      if (editCourseData.requirements) {
        try {
          setRequirementList(JSON.parse(editCourseData.requirements));
        } catch (error) {
          setRequirementList([{ requirement: "" }]);
        }
      }

      if (editCourseData.metaKeywords) {
        setTags(editCourseData.metaKeywords.split(","));
      }

      form.setFieldsValue({
        categoryId: editCourseData.categoryId,
        courseOverviewProvider: editCourseData.courseOverviewProvider,
        courseType: value,
        duration: editCourseData.duration,
        description: editCourseData.description,
        discountFlag: editCourseData.discountFlag == 1 ? true : false,
        discountedPrice: editCourseData.discountedPrice,
        enableDripContent: editCourseData.enableDripContent,
        expiryPeriod: editCourseData.expiryPeriod,
        duration: editCourseData.duration,
        duration: editCourseData.duration,
        courseOverviewProvider: editCourseData.courseOverviewProvider,
        language: editCourseData.language,
        level: editCourseData.level,
        keywords: editCourseData.metaKeywords,
        metaDescription: editCourseData.metaDescription,
        price: editCourseData.price,
        shortDescription: editCourseData.shortDescription,
        courseTitle: editCourseData.title,
        videoUrl: editCourseData.videoUrl,
        isTopCourse: editCourseData.isTopCourse,
      });
      setValue(editCourseData?.status)
    }

    setThumbnailURL(editCourseData?.thumbnail)
    setValue(editCourseData?.courseType)
  }, [editCourseData]);

  const [isPostLoading, postError, postData] = usePost();
  const [activeTab, setActiveTab] = useState("1");


  
  const handleImageUpload = (filePath) => {
    setThumbnailURL(filePath);
  };

  const handleCategoryChange = (value) => {
    form.setFieldValue("categoryId", value);
  };

  const onChange = (e) => {
    console.log("radio checked", e.target.value);

    setValue(e.target.value);
  };

  const onChangeForExpiry = (e) => {
    console.log("radio checked", e.target.value);
    setValueForExpiry(e.target.value);
  };

  const handleClose = (removedTag) => {
    setTags(tags.filter((tag) => tag !== removedTag));
  };

  const handleInputConfirm = () => {
    if (inputValue && !tags.includes(inputValue)) {
      setTags([...tags, inputValue]);
    }
    setInputVisible(false);
    setInputValue("");
  };

  const handleFaqChange = (index, field, value) => {
    const updatedFaqs = [...faqList];
    updatedFaqs[index][field] = value;
    setFaqList(updatedFaqs);
  };

  const handleOutcomeChange = (index, value) => {
    const updatedOutcomes = [...outcomesList];
    updatedOutcomes[index] = { outcome: value };
    setOutcomesList(updatedOutcomes);
  };

  const handleRequirementChange = (index, value) => {
    const updatedRequirementList = [...requirementList];
    updatedRequirementList[index] = { requirement: value };
    setRequirementList(updatedRequirementList);
  };

  const onChangeRadiobtn = (checked) => {
    setChecked(checked);
    console.log("Switch is now:", checked ? "ON" : "OFF");
  };

  const handleCheckboxChangeForFreeCourse = (e) => {
    setIsCheckedForFreeCourse(e.target.checked);
  };

  const handleCheckboxChangeForTopCourse = (e) => {
    form.setFieldsValue({ isTopCourse: e.target.checked });
  };

  const handleCheckboxChangeDiscountedPrice = (e) => {
    setIsCheckedForDiscountedPrice(e.target.checked);
  };

  const onFinish = async (values) => {
    setLoading(true);
    console.log(values,)

    // let formDataToPost = {
    //   categoryId: values.categoryId,
    //   courseOverviewProvider: values.courseOverviewProvider,
    //   courseType: value,
    //   duration: values.duration,
    //   dateAdded:id ? editCourseData?.dateAdded : new Date().toISOString().split("T")[0],
    //   description: values.description,
    //   discountFlag: (values.discountFlag == true ? 1 : 0) ?? 0,
    //   discountedPrice: values.discountedPrice,
    //   enableDripContent: values.enableDripContent,
    //   expiryPeriod: values.expiryPeriod,
    //   faqs: JSON.stringify(faqList),
    //   isFreeCourse: isCheckedForFreeCourse,
    //   isTopCourse: values.isTopCourse,
    //   language: values.language,
    //   level: values.level,
    //   metaDescription: values.metaDescription,
    //   metaKeywords: tags.toString(),
    //   multiInstructor: false,
    //   outcomes: JSON.stringify(outcomesList),
    //   price: values.coursePrice,
    //   requirements: JSON.stringify(requirementList),
    //   section: "",
    //   shortDescription: values.shortDescription,
    //   thumbnail :  null,
    //   // status: "<string>",
    //   subCategoryId: 0,
    //   title: values.courseTitle,
    //   videoUrl: values.videoUrl,
    //   userId : userData?.id
    // };

    if (thumbnailURL != null || thumbnailURL != undefined) {
      editCourse.thumbnail = thumbnailURL;
    }

    try {
     
      if (id) {
        const updatedCourse = {
          ...editCourse,
          courseType: value,
          faqs: JSON.stringify(faqList),
          requirements:JSON.stringify(requirementList),
          outcomes : JSON.stringify(outcomesList)
        };
      
        const res = await postData(`course/update`, updatedCourse, true);
      
        if (res) {
          console.log("----", res);
          navigate(-1);
        }
      }
      
    } catch (err) {
      console.error("Submission error:", err);
    } finally {
    }
  };

  const handleAdd = () => {
    setFaqList([...faqList, { question: "", answer: "" }]);
  };

  const handleRemove = (index) => {
    const updatedFaqList = faqList.filter((_, i) => i !== index);
    setFaqList(updatedFaqList);
  };

  const handleAddRequirement = () => {
    setRequirementList([...requirementList, { requirement: "" }]);
  };

  const handleRemoveRequirement = (index) => {
    const updatedRequirementList = requirementList.filter(
      (_, i) => i !== index
    );
    setRequirementList(updatedRequirementList);
  };
  const handleAddOutcomes = () => {
    setOutcomesList([...outcomesList, { outcome: "" }]);
  };

  const handleRemoveOutcomes = (index) => {
    const updatedOutcomes = outcomesList.filter((_, i) => i !== index);
    setOutcomesList(updatedOutcomes);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const nextTab = () => {
    setActiveTab((prev) => (parseInt(prev) + 1).toString());
  };

  const prevTab = () => {
    setActiveTab((prev) => (parseInt(prev) - 1).toString());
  };



  useEffect(() => {
    if (editCourseData) {
      // console.log("Updated State:", editCourseData);
      // set data in form fields
      form.setFieldsValue({
        courseTitle: editCourseData.title,
        description: editCourseData.description,
        categoryId: editCourseData.categoryId,
        level: editCourseData.level,
        language: editCourseData.language,
        enableDripContent: editCourseData.enableDripContent,
        courseType: editCourseData.courseType,
        expiryPeriod: editCourseData.expiryPeriod,
        remember: editCourseData.isTopCourse,
        coursePrice: editCourseData.price,
        discountedPrice: editCourseData.discountedPrice,
        courseDuration: editCourseData.duration,
        url: editCourseData.url,
        keywords: editCourseData.keywords,
        imageUrl: editCourseData.imageUrl,
        question: editCourseData.faqList,
        requirement: editCourseData.requirement,
        status:editCourseData.status
      });

      setValueForExpiry(editCourseData.expiryPeriod)
    }
  }, [editCourseData]);

  useEffect(() => {
    if (categoriesData && categoriesData.content) {
      const options = categoriesData.content.map((category) => ({
        value: category.id,
        label: `#${category.id} ${category.name}`,
      }));
      setCategoryOptions(options);
    }
  }, [categoriesData]);


  const handleChange = (key, value) => {
    setEditCourse((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  useEffect(() => {
    console.log(editCourseData,'//')
  },[editCourseData])


  return (
    <div className=" mt-50"
    
    >
      <PageHeader
        title={
         'Edit Course'
        }
      />
      {/* <div > */}

        <div style={{padding:'10px',backgroundColor:'white',marginTop:'20px'}}>
        <Tabs activeKey={activeTab}  onChange={setActiveTab}
        >
            
                      <TabPane
                        tab={
                            <span>
                            <HomeOutlined /> Curriculum
                            </span>
                        }
                        key="1"
                    >

                        <div className='curriculum_div'>

                        <CurriculumCard /> 
                        </div>

                        <div style={{ display: "flex", justifyContent: "center",marginTop:"20px" }}>
                        <Button
                          style={{ marginRight: "10px" }}
                          icon={<LeftOutlined />}
                          onClick={prevTab}
                        />
                        <Button
                          icon={<RightOutlined />}
                          type="primary"
                          onClick={nextTab}
                        />
                      </div>
                    </TabPane>


                    <TabPane
                        tab={
                            <span>
                            <HomeOutlined /> Academic progress
                            </span>
                        }
                        key="2"
                    >

                        <AcademicProgres />
                        

                        <div style={{ display: "flex", justifyContent: "center",marginTop:"20px" }}>
                        <Button
                          style={{ marginRight: "10px" }}
                          icon={<LeftOutlined />}
                          onClick={prevTab}
                        />
                        <Button
                          icon={<RightOutlined />}
                          type="primary"
                          onClick={nextTab}
                        />
                      </div>
                    </TabPane>


                    <TabPane
                        tab={
                            <span>
                            <HomeOutlined /> Bbb Live class
                            </span>
                        }
                        key="3"
                    >

                    
                        <BbbClasses/>
                      <div style={{ display: "flex", justifyContent: "center",marginTop:"20px" }}>
                        <Button
                          style={{ marginRight: "10px" }}
                          icon={<LeftOutlined />}
                          onClick={prevTab}
                        />
                        <Button
                          icon={<RightOutlined />}
                          type="primary"
                          onClick={nextTab}
                        />
                      </div>
                    </TabPane>
                      

              

                    <TabPane
                        tab={
                            <span>
                            <HomeOutlined /> Zoom live settings
                            </span>
                        }
                        key="4"
                    >

                        <ZoomSetting />
                    
                      <div style={{ display: "flex", justifyContent: "center",marginTop:"20px" }}>
                        <Button
                          style={{ marginRight: "10px" }}
                          icon={<LeftOutlined />}
                          onClick={prevTab}
                        />
                        <Button
                          icon={<RightOutlined />}
                          type="primary"
                          onClick={nextTab}
                        />
                      </div>
                    
                    </TabPane> 
                    

          {/* Basic Tab */}
          <TabPane
            tab={
              <span>
                <HomeOutlined /> Basic
              </span>
            }
            key="5"
          >
    
          <Form form={form} onFinish={onFinish} autoComplete="off"
            layout="vertical"
          >      
            <Form.Item
              label="Course title"
              name="courseTitle"
              rules={[
                {
                  required: true,
                  message: "Please input your Course title!",
                },
              ]}
            >
              <Input 
                  onChange={(e) => handleChange("title", e.target.value)}
                
              />
            </Form.Item>

            <Form.Item label="Short description"
              name="shortDescription"
              rules={[
                {
                  required: true,
                  message: "Please input your Course title!",
                },
              ]}
            >
              <Input.TextArea 
                onChange={(e) => handleChange("shortDescription", e.target.value)}
              />
            </Form.Item>

            <Form.Item
              label="Course Description"
              name="description"
              rules={[
                {
                  required: true,
                  message: "Please enter the course description!",
                },
              ]}
            >
              <Input 
                onChange={(e) => handleChange("description", e.target.value)}
              />
            </Form.Item>

            <Form.Item
             label="Select a Category"
              name="categoryId"
              rules={[
                {
                  required: true,
                  message: "Please select a category!",
                },
              ]}
            >
              <SearchSelect
                // label="Select a Category"
                treeData={categoryOptions}
                onChangeValue={handleCategoryChange}
              />
            </Form.Item>

            <Form.Item
              name="duration"
              label="Course Duration (No. of days)"
              rules={[
                {
                  required: true,
                  message: "Please select a valid duration for the course!",
                },
              ]}
            >
              <Input type="number" min={1}
                onChange={(e) => handleChange("duration", e.target.value)}
              >
                
              </Input>
            </Form.Item>

            <Form.Item
              name="level"
              label="Level"
              rules={[
                { required: true, message: "Please select an option!" },
              ]}
            >
              <Select
                showSearch
                placeholder="Search to select"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                <Option value="Beginner">Beginner</Option>
                <Option value="Advanced">Advanced</Option>
                <Option value="Intermediate">Intermediate</Option>
              </Select>
            </Form.Item>

            <Form.Item
              name="language"
              label="Language made in"
              rules={[
                { required: true, message: "Please select an option!" },
              ]}
            >
              <Select
                showSearch
                placeholder="Search to select"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                <Option value="English">English</Option>
                <Option value="Telugu">Telugu</Option>
                <Option value="Hindi">Hindi</Option>
              </Select>
            </Form.Item>

            <Form.Item
              name="enableDripContent"
              label="Enable drip content"
              valuePropName="checked"
              initialValue={false}
            >
              <Switch
                checked={checked}
                onChange={onChangeRadiobtn}
                checkedChildren="On"
                unCheckedChildren="Off"
              />
            </Form.Item>

            <Form.Item
              name="status"
              label="Create as a"
              
            >
              <Radio.Group onChange={onChange}>
                <Space direction="vertical">
                  <Radio value={'active-course'}>Active course</Radio>
                  <Radio value={'private-course'}>Private course</Radio>
                  <Radio value={'upcoming-course'}>Upcoming course</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              name="isTopCourse"
              valuePropName=""
              onChange={handleCheckboxChangeForTopCourse}
            >
              <Checkbox>Check if this course is top course</Checkbox>
            </Form.Item>

            {/* <Form.Item label={null}>
                  <Button type="primary" htmlType="submit">
                    Submit
                  </Button>
                </Form.Item>
          */}
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                style={{ marginRight: "10px" }}
                icon={<LeftOutlined />}
                disabled
              />
              <Button
                icon={<RightOutlined />}
                type="primary"
                onClick={nextTab}
              />
            </div>
            </Form>
          </TabPane>

          {/* Info Tab */}
          <TabPane
            tab={
              <span>
                <InfoCircleOutlined /> Info
              </span>
            }
            key="6"
          >
          <Form form={form} onFinish={onFinish} autoComplete="off"
             layout="vertical"
          >  
          <Form.Item label="Course FAQ">
                  {faqList.map((faq, index) => (
                    <Row
                      key={index}
                      gutter={16}
                      align="middle"
                      style={{ marginBottom: "16px" }}
                    >
                      <Col span={8}></Col>
                      <Col span={12}>
                        <Form.Item
                          name={["faqList", index, "question"]}
                          rules={[
                            {
                              required: true,
                              message: "Please input the FAQ question!",
                            },
                          ]}
                          initialValue={faq.question}
                        >
                          <Input
                            placeholder="Faq question"
                            value={faq.question}
                            onChange={(e) =>
                              handleFaqChange(
                                index,
                                "question",
                                e.target.value
                              )
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={2}>
                        <Button
                          type="primary"
                          danger={index !== 0}
                          icon={
                            index === 0 ? (
                              <PlusOutlined />
                            ) : (
                              <MinusOutlined />
                            )
                          }
                          onClick={
                            index === 0
                              ? handleAdd
                              : () => handleRemove(index)
                          }
                          style={{ width: "100%", marginBottom: "22px" }}
                        >
                          {index === 0 ? "" : ""}
                        </Button>
                      </Col>
                      <Col span={8}></Col>
                      <Col span={12}>
                        <Form.Item
                          name={["faqList", index, "answer"]}
                          rules={[
                            {
                              required: true,
                              message: "Please input the FAQ answer!",
                            },
                          ]}
                          initialValue={faq.answer}
                        >
                          <Input.TextArea
                            placeholder="Answer"
                            rows={3}
                            value={faq.answer}
                            onChange={(e) =>
                              handleFaqChange(
                                index,
                                "answer",
                                e.target.value
                              )
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={3}></Col>
                    </Row>
                  ))}
                </Form.Item>

                <Form.Item label="Requirements">
                  {requirementList.map((requirement, index) => (
                    <Row
                      key={index}
                      gutter={16}
                      align="middle"
                      style={{ marginBottom: "16px" }}
                    >
                      <Col span={8}></Col>
                      <Col span={12}>
                        <Form.Item
                          name={["requirement", index]}
                          rules={[
                            {
                              required: true,
                              message: "Please input the requirement!",
                            },
                          ]}
                          initialValue={requirement.requirement}
                        >
                          <Input
                            placeholder="Provide Requirement"
                            value={requirement.requirement}
                            onChange={(e) =>
                              handleRequirementChange(index, e.target.value)
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={2}>
                        <Button
                          type="primary"
                          danger={index !== 0}
                          icon={
                            index === 0 ? (
                              <PlusOutlined />
                            ) : (
                              <MinusOutlined />
                            )
                          }
                          onClick={
                            index === 0
                              ? handleAddRequirement
                              : () => handleRemoveRequirement(index)
                          }
                          style={{ width: "100%", marginBottom: "22px" }}
                        />
                      </Col>
                    </Row>
                  ))}
                </Form.Item>


                <Form.Item label="Outcomes">
                  {outcomesList.map((outcome, index) => (
                    
                    <Row
                      key={index}
                      gutter={16}
                      align="middle"
                      style={{ marginBottom: "16px" }}
                    >
                      <Col span={8}></Col>
                      <Col span={12}>
                        <Form.Item
                          name={["outcomes", index]}
                          rules={[
                            {
                              required: true,
                              message: "Please input the outcome!",
                            },
                          ]}
                          initialValue={outcome.outcome}
                        >
                          <Input
                            placeholder="Provide Outcomes"
                            value={outcome.outcome}
                            onChange={(e) =>
                              handleOutcomeChange(index, e.target.value)
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={2}>
                        <Button
                          type="primary"
                          danger={index !== 0}
                          icon={
                            index === 0 ? (
                              <PlusOutlined />
                            ) : (
                              <MinusOutlined />
                            )
                          }
                          onClick={
                            index === 0
                              ? handleAddOutcomes
                              : () => handleRemoveOutcomes(index)
                          }
                          style={{ width: "100%", marginBottom: "22px" }}
                        />
                      </Col>
                      <Col span={8}></Col>
                    </Row>
                  ))}
                </Form.Item>
            

            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                style={{ marginRight: "10px" }}
                icon={<LeftOutlined />}
                onClick={prevTab}
              />
              <Button
                icon={<RightOutlined />}
                type="primary"
                onClick={nextTab}
              />
            </div>
            </Form>
          </TabPane>



          {/* Pricing Tab */}
          <TabPane
            tab={
              <span>
                <PayCircleOutlined /> Pricing
              </span>
            }
            key="7"
          >
            <Form form={form} onFinish={onFinish} autoComplete="off"
             layout="vertical"
            >  
            <Form.Item name="isFreeCourse" valuePropName="" label={null}>
              <Checkbox onChange={handleCheckboxChangeForFreeCourse}>
                Check if this is a free course
              </Checkbox>
            </Form.Item>

            {!isCheckedForFreeCourse && (
              <>
                <Form.Item label="Course price ($)" name="price">
                  <Input 
                    onChange={(e) => handleChange("price", e.target.value)}
                  />
                </Form.Item>

                <Form.Item
                  name="discountFlag"
                  valuePropName="checked"
                  label={null}
                >
                  <Checkbox onChange={handleCheckboxChangeDiscountedPrice}>
                    Check if this course has discount
                  </Checkbox>
                </Form.Item>

                {isCheckedForDiscountedPrice && (
                  <Form.Item
                    label="Discounted price"
                    name="discountedPrice"
                  >
                    <Input />
                  </Form.Item>
                )}
              </>
            )}
            <Form.Item
              name="expiryPeriod"
              label="Expiry period"
              initialValue={1} // Default value is "Lifetime"
            >
              <Radio.Group
                onChange={onChangeForExpiry}
                value={valueForExpiry}
              >
                <Space direction="horizontal">
                  <Radio value={1}>Lifetime</Radio>
                  <Radio value={2}>Limited time</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>

            {valueForExpiry === 2 && (
              <>
                <Form.Item label="Number of months" name="courseDuration">
                  <Input onChange={(e) => handleChange("courseDuration", e.target.value)}/>
                </Form.Item>

                <Form.Item>
                  <label>
                    After purchase, students can access the course until
                    your selected time.
                  </label>
                </Form.Item>
              </>
            )}

            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                style={{ marginRight: "10px" }}
                icon={<LeftOutlined />}
                onClick={prevTab}
              />
              <Button
                icon={<RightOutlined />}
                type="primary"
                onClick={nextTab}
              />
            </div>
            </Form>
          </TabPane>



          {/* Media Tab */}
          <TabPane
            tab={
              <span>
                <CameraOutlined /> Media
              </span>
            }
            key="8"
          >
            <Form form={form} onFinish={onFinish} autoComplete="off"
             layout="vertical"
            >  
            <Form.Item
              label="Course overview provider"
              name="courseOverviewProvider"
            >
              <Select
                showSearch
                placeholder="Search to select"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                <Option value="1">Youtube</Option>
                <Option value="2">Vimeo</Option>
                <Option value="3">HTML5</Option>
              </Select>
            </Form.Item>

            <Form.Item
              label="Course overview url"
              name="videoUrl"
              rules={[
                {
                  required: true,
                  message: "Please input your video url!",
                },
              ]}
            >
              <Input 
                onChange={(e) => handleChange("videoUrl", e.target.value)}
              />
            </Form.Item>

            <Form.Item
              label="Select image"
              name="thumbnail"
              rules={[
                  {
                  required: true,
                  message: "Please select image!",
                },
              ]}
            >
                <ImageUploader
                  subdir="course_images"
                  onImageUpload={handleImageUpload}
                  imageUrl={editCourseData?.thumbnail}
                />
            </Form.Item>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                style={{ marginRight: "10px" }}
                icon={<LeftOutlined />}
                onClick={prevTab}
              />
              <Button
                icon={<RightOutlined />}
                type="primary"
                onClick={nextTab}
              />
            </div>
            {/* </Form> */}
            </Form>
          </TabPane>

          {/* SEO Tab */}
          <TabPane
            tab={
              <span>
                <SearchOutlined /> SEO
              </span>
            }
            key="9"
          >
          <Form form={form} onFinish={onFinish} autoComplete="off"
           layout="vertical"
          >  
            <Form.Item
              label="Meta Keywords"
              name="keywords"
              rules={[
                {
                  required: true,
                  message: "Please add at least one keyword",
                },
              ]}
            >
              <>
                <div
                  style={{
                    border: "1px solid #d9d9d9",
                    padding: "4px",
                    borderRadius: "4px",
                    minHeight: "40px",
                  }}
                >
                  {tags.map((tag) => (
                    <Tag
                      key={tag}
                      closable
                      onClose={() => handleClose(tag)}
                      style={{ marginBottom: "4px" }}
                    >
                      {tag}
                    </Tag>
                  ))}
                  {inputVisible ? (
                    <Input
                      size="small"
                      style={{ width: "150px", marginBottom: "4px" }}
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                      onBlur={handleInputConfirm}
                      onPressEnter={handleInputConfirm}
                      autoFocus
                    />
                  ) : (
                    <Tag
                      onClick={() => setInputVisible(true)}
                      style={{
                        background: "#fff",
                        borderStyle: "dashed",
                        cursor: "pointer",
                      }}
                    >
                      <PlusOutlined /> Add keyword
                    </Tag>
                  )}
                </div>
              </>
            </Form.Item>

            <Form.Item 
              label="Meta description" 
              name="metaDescription">
              <Input.TextArea 
                  onChange={(e) => handleChange("metaDescription", e.target.value)}
              />
            </Form.Item>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                style={{ marginRight: "10px" }}
                icon={<LeftOutlined />}
                onClick={prevTab}
              />
              <Button
                icon={<RightOutlined />}
                type="primary"
                onClick={nextTab}
              />
            </div>
            </Form>
          </TabPane>

          {/* Finish Tab */}
          <TabPane
            tab={
              <span>
                <CheckCircleOutlined /> Finish
              </span>
            }
            key="10"
          >
            <div className="finish_tab">
              <h5>Thank you</h5>
              <p className="finish_tag">You are just one click away</p>
              <button className="finish_submit_btn"
                onClick={onFinish}
              >Submit</button>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "10px",
              }}
            >
              <Button
                style={{ marginRight: "10px" }}
                icon={<LeftOutlined />}
                onClick={prevTab}
              />
              <Button icon={<RightOutlined />} type="primary" disabled />
            </div>
          </TabPane>
          {/* </Form> */}
          </Tabs>
      </div>
    </div>

  );
};

export default EditCourse;
